export const SubscriptionEnabledState = 'enabled';
